import { render, staticRenderFns } from "./KnProductUOM.vue?vue&type=template&id=b6ecf4fc&"
import script from "./KnProductUOM.vue?vue&type=script&lang=js&"
export * from "./KnProductUOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports